import { render, staticRenderFns } from "./SelectedPromotions.vue?vue&type=template&id=c5ab2a5c"
import script from "./SelectedPromotions.vue?vue&type=script&lang=js"
export * from "./SelectedPromotions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports